define('app/views/checkout_onepage_top_nav_view',['app/setup'], function(takhfifan) {
  takhfifan.checkoutOnepageTopNavView = Backbone.View.extend({
    initialize: function(options) {
      var _this = this,
          productsDetail = this.$el.data('itemdetails'),
          gaCommands = [],
          checkoutOpts = {};
      _this.successItems(_this);

      _this.isGuest = this.$el.data('isguest');

      _.each(productsDetail, function(product){
        gaCommands.push({
          command: "ec:addProduct",
          options: product
        });
      });
      var $currentStep = $('.checkout-steps .active'),
          pageViewParams = {};
      if($currentStep.hasClass('login-step')){
        checkoutOpts.step = 2;
        pageViewParams={
          title: i18n.t('login'),
          path: "login"
        }
      }else if($currentStep.hasClass('payment-step')){
        checkoutOpts.step = 4;
        pageViewParams = {
          title: i18n.t('payment'),
          path: "payment"
        }
      }else if($currentStep.hasClass('shipping-step')){
        checkoutOpts.step = 3;
        pageViewParams ={
          title: i18n.t('shipping'),
          path: "shipping"
        }
      }
      gaCommands.push({
        command: "ec:setAction",
        param: "checkout",
        options:checkoutOpts
      });
      pageViewParams.commands = gaCommands;

      if(_.has(pageViewParams, 'path')) {
        takhfifan.eventHub.trigger('ga:sendPageView', pageViewParams);
      }

      takhfifan.eventHub.on('checkout:payment', function(data) {
        this.$('.shipping-step').removeClass('active');
        this.$('.login-step').removeClass('active');
        this.$('.payment-step').addClass('active');
        _this.successItems(_this);
        gaCommands.push({
          command: "ec:setAction",
          param: "checkout",
          options: {step: 4},
          products: productsDetail
        });
        takhfifan.eventHub.trigger('ga:sendPageView', {
          title: i18n.t('payment'),
          path: "payment",
          commands: gaCommands
        });
      }, this);
      takhfifan.eventHub.on('checkout:shipping', function(data) {
        this.$('.payment-step').removeClass('active');
        this.$('.login-step').removeClass('active');
        this.$('.shipping-step').addClass('active');
        _this.successItems(_this);
        gaCommands.push({
          command: "ec:setAction",
          param: "checkout",
          options: {step: 3},
          products: productsDetail
        });
        if($('.tkh-guest-checkout-user-address-info').length){
          takhfifan.eventHub.trigger('ga:sendPageView', {
            title: i18n.t('address'),
            path: "address"
          });
        }else{
          takhfifan.eventHub.trigger('ga:sendPageView', {
            title: i18n.t('shipping'),
            path: "shipping",
            commands: gaCommands
          });
        }
      }, this);
      takhfifan.eventHub.on('guest_customer_address_info:saved', function(data) {
        gaCommands.push({
          command: "ec:setAction",
          param: "checkout",
          options: {step: 3},
          products: productsDetail
        });
        takhfifan.eventHub.trigger('ga:sendPageView', {
          title: i18n.t('shipping'),
          path: "shipping",
          commands: gaCommands
        });
      });
      takhfifan.eventHub.on('checkout:login', function(data) {
        this.$('.payment-step').removeClass('active');
        this.$('.shipping-step').removeClass('active');
        this.$('.login-step').addClass('active');
        _this.successItems(_this);
        gaCommands.push({
          command: "ec:setAction",
          param: "checkout",
          options: {step: 2},
          products: productsDetail
        });

        takhfifan.eventHub.trigger('ga:sendPageView', {
          title: i18n.t('login'),
          path: "login",
          commands: gaCommands
        });

      }, this);
      takhfifan.eventHub.on('customer:login', function(customer) {
        if(_this.isGuest) {
          window.location.reload();
        }
      });
    },
    successItems: function(el){
      el.$('li.active').removeClass('success');
      el.$('li.active').prevAll().addClass('success');
    }

  });
});

